// extracted by mini-css-extract-plugin
export default {"summary":"Summary-module__summary__ep3Yt","content":"Summary-module__content__62dv2","title":"Summary-module__title__Rf5XI"};